import { MainPaceTask } from 'providence-types';
import { MainPaceTasksWithKeys } from '../types/main-pace-tasks-with-keys';

export const ACCOUNTING_PACE_TASKS: MainPaceTasksWithKeys = {
  RE015: MainPaceTask.LeasingComplete,
  RE020: MainPaceTask.SiteAcqComplete,
  RE066: MainPaceTask.ZoningAppDeemedComplete,
  SS010: MainPaceTask.CandidateApproved,
};
